import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Page } from "@/components/SiteLayout";
import AdminInvites from "@/components/AdminInvites";

const OfferRow = ({ o, onChange }) => (
  <div className="rounded-2xl border bg-white p-4" data-testid={`admin-offer-${o.id}`}>
    <div className="flex items-center justify-between">
      <b className="text-stone-900">{o.name}</b>
      <label className="flex items-center gap-2 text-sm">
        <input type="checkbox" checked={o.active} onChange={(e) => onChange({ ...o, active: e.target.checked })} data-testid={`admin-offer-${o.id}-active`} /> Ativo
      </label>
    </div>
    <input className="field mt-3" placeholder={o.kind === "whatsapp" ? "Link do WhatsApp (https://wa.me/...)" : "URL do checkout"} value={o.url} onChange={(e) => onChange({ ...o, url: e.target.value })} data-testid={`admin-offer-${o.id}-url`} />
    <input className="field mt-2" placeholder="Preço exibido (ex.: R$ 497)" value={o.price} onChange={(e) => onChange({ ...o, price: e.target.value })} data-testid={`admin-offer-${o.id}-price`} />
  </div>
);

export default function AdminPage() {
  const [key, setKey] = useState("");
  const [cfg, setCfg] = useState(null);
  const headers = { "X-Admin-Key": key };

  const load = async () => {
    try {
      setCfg((await api.get("/admin/commercial", { headers })).data);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const save = async () => {
    try {
      const offers = Object.fromEntries(cfg.offers.map((o) => [o.id, o]));
      setCfg((await api.put("/admin/commercial", { checkout_url: cfg.checkout_url, offers }, { headers })).data);
      toast.success("Links comerciais salvos.");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const setOffer = (o) => setCfg({ ...cfg, offers: cfg.offers.map((x) => (x.id === o.id ? o : x)) });

  return (
    <Page>
      <div className="mx-auto max-w-xl px-5 py-10" data-testid="admin-page">
        <h1 className="text-3xl text-stone-900">Links comerciais</h1>
        {!cfg ? (
          <>
            <input className="field mt-6" type="password" placeholder="Chave administrativa" value={key} onChange={(e) => setKey(e.target.value)} data-testid="admin-key-input" />
            <button className="btn-primary mt-3 w-full" onClick={load} data-testid="admin-login-button">Entrar</button>
          </>
        ) : (
          <div className="mt-6 space-y-4">
            <label className="block text-sm font-medium text-stone-700">Checkout Kiwify do Mapa (R$ 47)
              <input className="field mt-2" value={cfg.checkout_url} onChange={(e) => setCfg({ ...cfg, checkout_url: e.target.value })} data-testid="admin-checkout-url" />
            </label>
            {cfg.offers.map((o) => <OfferRow key={o.id} o={o} onChange={setOffer} />)}
            <button className="btn-primary w-full" onClick={save} data-testid="admin-save-button">Salvar</button>
            <AdminInvites adminKey={key} />
          </div>
        )}
      </div>
    </Page>
  );
}
